import React, { FC, useState } from 'react'
import {
  Breakpoint,
  useCurrentBreakpoint
} from '../../../hooks/CurrentBreakpoint'
import {
  StandingsInterface,
  StandingsColumnInterface,
  StandingsRowInterface
} from './Standings.interface'
import { ExpandedToggle } from './ExpandedToggle/ExpandedToggle'
import { StandingsRow } from './StandingsRow/StandingsRow'
import { StandingsHeader } from './StandingsHeader/StandingsHeader'
import { createGridTemplateColumns } from './createGridTemplateColumns'
import { getTableBasedOnTeamSlug } from './getTableBasedOnTeam'
import { getArrowToShow } from './getArrowToShow'
import classNames from 'classnames'
import styles from './Standings.module.scss'

interface StandingsTableProps {
  standings: StandingsInterface
  showExpandedToggle: boolean
  teamSlug?: string
}

export const StandingsTable: FC<StandingsTableProps> = ({
  standings,
  showExpandedToggle,
  teamSlug
}) => {
  const [expanded, setExpanded] = useState(!showExpandedToggle)

  const currentBreakpoint = useCurrentBreakpoint()
  const isMobile = currentBreakpoint <= Breakpoint.sm
  const columns: StandingsColumnInterface[] = standings.columns
  const rows: StandingsRowInterface[] = standings.rows

  const listBasedOnTeam =
    teamSlug && rows && getTableBasedOnTeamSlug(rows, teamSlug)

  const rowsToUse =
    listBasedOnTeam && listBasedOnTeam?.length > 0
      ? listBasedOnTeam
      : rows.slice(0, 4)

  const showEvenRowsColor = !listBasedOnTeam || expanded
  const rowsShown = !showExpandedToggle || expanded ? rows : rowsToUse
  const gridTemplateColumns = createGridTemplateColumns(columns, isMobile)
  const arrowToShow = getArrowToShow(rowsShown, expanded)

  return (
    <div className={styles.StandingsTable}>
      <div className={styles.Table} data-testid="standings-table">
        <h4 className={styles.GroupTitle}>{standings.groupName}</h4>
        <StandingsHeader
          columns={columns}
          gridTemplateColumns={gridTemplateColumns}
        />
        <div data-testid="standings-rows">
          {rowsShown.length > 0 &&
            rowsShown.map((row: any, rowIndex: number) => {
              const name: string = row[columns[0].field].toString()
              const channel = row?.subdomain?.toString()
              const placement = listBasedOnTeam
                ? row.DisplayOrder
                : rowIndex + 1
              const isLastBeforeDivider = !!row.isLastBeforeDivider
              const isLastPlacement = placement === rowsShown.length
              const isPreSelected = row.selectedTeam
              return (
                <div
                  className={classNames({
                    [styles.Even]: showEvenRowsColor && rowIndex % 2
                  })}
                  key={`StandingsRow__${name}__${rowIndex}`}
                >
                  <StandingsRow
                    key={`StandingsRow__${name}__${rowIndex}`}
                    row={row}
                    name={name}
                    channel={channel}
                    columns={columns}
                    placement={placement}
                    isLastBeforeDivider={isLastBeforeDivider}
                    isLastPlacement={isLastPlacement}
                    isPreSelected={isPreSelected}
                    gridTemplateColumns={gridTemplateColumns}
                  />
                </div>
              )
            })}
        </div>
      </div>
      {showExpandedToggle && rows.length > 3 && (
        <ExpandedToggle
          expanded={expanded}
          onToggleExpanded={() => setExpanded((prev) => !prev)}
          arrowIconToShow={arrowToShow}
        />
      )}
    </div>
  )
}
